import AllocationCalendarWithContact from '../AllocationCalendarWithContact'

export default class GetAllocationCalendarsMutationPayload {
  calendars: AllocationCalendarWithContact[]

  constructor (calendars: AllocationCalendarWithContact[]) {
    this.calendars = calendars
  }
}
